export const JAPA_LABS_URL = "https://japa.health/labs";
export const JAPA_SEARCH_URL = "https://japa.health/search/";

/** Consent form landing page — current Book a Consult redirect target. */
export const BOOK_CONSULT_CONSENT_URL =
  "https://japa.health/japa-health-11-consult-consent-form/";

/**
 * Calendly booking link — reserved for future Mailchimp tag bypass.
 * Override via REACT_APP_BOOK_CONSULT_CALENDLY_URL when wired up.
 */
export const BOOK_CONSULT_CALENDLY_URL =
  process.env.REACT_APP_BOOK_CONSULT_CALENDLY_URL || "";
